module.exports = __webpack_public_path__ + "img/Icon-awesome-angle-right.a7341b0c.svg";